import React from 'react';
import { motion } from 'framer-motion';
interface FadeUpProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}
export function FadeUp({
  children,
  delay = 0,
  className = ''
}: FadeUpProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 28
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-10%'
  }} transition={{
    duration: 0.7,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-238">
      {children}
    </motion.div>;
}